import Vue from 'vue';
import { departmentEnum } from '@/shared/enum';
import UserService from '@/app/user/user.service';

const getDefaultState = () => ({
    isLoggedIn: false,
    accessToken: null,
    refreshToken: null,
    friendlyUsername: null,
    role: null,
    auswertung: false,
    department: null,
    userId: null,
    authorities: [],
});

const auth = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            state = Object.assign({}, getDefaultState(), data);
        },
        updateFriendlyUsername(state, data) {
            Vue.set(state, 'friendlyUsername', data);
        },
        updateAuthorities(state, data) {
            Vue.set(state, 'authorities', data);
        },
        clear(state) {
            // eslint-disable-next-line no-unused-vars
            state = Object.assign(state, getDefaultState());
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        update({ commit }, data) {
            commit('update', data);
        },
        updateFriendlyUsername(context, data) {
            context.commit('updateFriendlyUsername', data);
        },
        updateAuthorities(context, data) {
            context.commit('updateAuthorities', data);
        },
        async getAuthenticatedUser(context) {
            const { data } = await UserService.get(context.state.userId);
            return data;
        },
    },

    getters: {
        hasRoleUser(state) {
            if (Array.isArray(state.authorities)) {
                if (state.authorities.includes('STANDARD_ROLE')) return true;
            }
            return false;
        },
        hasRoleAdmin(state) {
            if (Array.isArray(state.authorities)) {
                if (state.authorities.includes('ADMIN_ROLE')) return true;
            }
            return false;
        },
        hasDepartmentVKI(state) {
            return state.department === departmentEnum().VKI;
        },
        hasDepartmentVKA(state) {
            return state.department === departmentEnum().VKA;
        },
        hasRoleAuswertung(state) {
            return state.auswertung;
        },
    },
};

export default auth;
